<template>
    <div class="container-fluid">
        <div class="row no-gutter">
            <div class="col-lg-3 bg-image"></div>
            <div class="col-lg-9">
                <div class="login d-flex align-items-center">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 col-md-8 mx-auto">
                                <div class="mb-8 text-center">
                                    <img class="img-fluid" src="/client/images/logo-login.png" />
                                </div>
                                
                                <div class="alert alert-danger" role="alert" v-if="error">
                                    <i class="fa fa-exclamation-triangle"></i>
                                    {{ error }}
                                </div>

                                <div class="form-group mb-2">
                                    <input
                                        class="form-control rounded"
                                        type="email"
                                        placeholder="E-mail"
                                        v-model="form.email"
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        class="form-control rounded"
                                        type="password"
                                        placeholder="Password"
                                        v-model="form.password"
                                    />
                                </div>

                                <div class="form-check mb-4 d-flex justify-content-between">
                                    <label class="form-check-label text-muted">
                                        <input
                                            class="form-check-input mr-2"
                                            type="checkbox"
                                            :value="1"
                                            v-model="form.remember_me"
                                        />

                                        <span class="small">Keep Me Signed in</span>
                                    </label>

                                    <router-link class="text-muted small" to="/forgot-password">
                                        <i class="fa fa-question-circle mr-2"></i>
                                        Forgot password?
                                    </router-link>
                                </div>

                                <button class="btn btn-secondary mb-4 w-100" type="button" v-on:click="login">
                                    Login
                                </button>
                            </div>
                            <div class="footer-address">
                                <small class="text-muted mx-auto">
                                    18 St George's Place, Cheltenham, Gloucestershire. GL50 3JZ
                                    <br />
                                    T: 01242 571883 | E: office@owltherapycentre.co.uk
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import authService from '@api/auth';

    export default Vue.extend({
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    remember_me: false
                },
                error: null
            };
        },
        methods: {
            login() {
                this.error = null;

                authService
                    .csrf()
                    .then(() => {
                        authService
                            .login(this.form)
                            .then(() => {
                                window.location.href = '/';
                            })
                            .catch((error) => {
                                if (error.response.data.message) {
                                    this.error = error.response.data.message;
                                } else {
                                    window.location.href = `/error/${error.response.status}`;
                                }
                            });
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    });
            }
        },
        created() {
            window.document.title = `Login | ${window.app.title}`;
        }
    });
</script>
